import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { Title } from 'src/types/landing-page';

function TitleH2BlockGradient({
  heading,
  theme,
}: {
  heading: Title;
  theme?: 'dark' | 'light';
}) {
  return (
    <h2
      className={ivclass(
        theme === 'dark' ? 'iv-text-grey-0' : 'iv-text-grey-100',
        'iv-text-heading-4xl lg:iv-text-heading-2xl md:iv-text-heading-2xl sm:iv-text-heading-2xs',
        'iv-m-heading-4xl lg:iv-m-heading-2xl md:iv-m-heading-2xl sm:iv-m-heading-2xs',
        'iv-font-extrabold iv-text-center iv-h-full',
      )}
    >
      {heading.plainHeading}
      <span className={ivclass('iv-block iv-h-full', 'iv-text-gradient-green')}>
        {heading.highlightedHeading}
      </span>
    </h2>
  );
}

export default TitleH2BlockGradient;
